import * as React from 'react';
import InformationOutline from '@2fd/ant-design-icons/lib/InformationOutline';
import Popover from 'antd/lib/popover';
import {
  useSelector,
} from 'react-redux';

export const ErrorHandlingCard = () => {
  const monitor = useSelector((state: any) => (state.errormonitor))
  const url = monitor?.url;
  const errormessage = monitor?.error?.stack;
    return (
        <>
        <div>
        <a href={url} target="_blank">
        <Popover placement="top" content={errormessage} trigger="hover">
        <InformationOutline className="errorhandle-icon"/>
        </Popover>
        </a>
      </div>
      </>
    );
}
